import React, {useState, useEffect ,useRef } from "react";
import ScrollPageTop from 'components/ui/ScrollPageTop'
import { Link, useNavigate } from "react-router-dom";
import { Tab } from '@headlessui/react'

import * as Yup from 'yup';
import {
   Control,
   FieldErrors,
   useForm,
   useFormState,
   useWatch,
   Controller
 } from 'react-hook-form';
 
import { yupResolver } from '@hookform/resolvers/yup';
import axios from 'axios';  
import {Links} from 'routes/PathLink'
import {
   API_ENDPOINT,
   APP_URL, 
   random_str, 
   toast_anim_error, 
   RAZOR_KEY, 
   loadScript,
   register_valid,
   register_fee,
   renew_per,
   pdfdoconly,
} from 'components/config/Common'
import Input from 'components/ui/input.jsx'
import 'react-phone-input-2/lib/bootstrap.css'
import Button from 'components/ui/Button.tsx'
import {useAuth} from 'contexts/provider/AuthProvider'
import Label from 'components/ui/label.tsx'
import {deviceDetect} from "react-device-detect";
//import MultiStep from 'react-multistep'
import PatientRegisterMain from "components/auth/user/PatientRegisterMain";
import Logo from "layouts/logo";
const UserRegister = () => {
   const navigate = useNavigate();
   const [loading, setLoading] = useState(false);
   const [selectedIndex, setSelectedIndex] = useState(0)
   const [step , setStep] = useState(2);


   const { login } = useAuth();
   
    const setActivestepfun = (val) => {
      console.log("Parent FUNCtion",val);
      setStep(val);
   }

    const Pagedisplay = () =>{
        return (
            <PatientRegisterMain setActivestepfun={setActivestepfun} />
          )
   }

   return(
      <ScrollPageTop>
         
        
         <div className="flex bg-white align-center">
            <div className="w-1/2 bg-cover bg-center min-h-screen hidden md:block" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${APP_URL}/img/userbg-reglog.png)`,backgroundSize:'cover',}} >
               <div className="px-4 py-3">
               <div className="flex w-full items-center lg:w-auto">
                    <Logo className={'ltr:ml-0 rtl:mr-0 text-white px-2 py-2 '} />
                </div>
                <h2 className="text-5xl text-white flex justify-center align-center mt-10">
                  Get a free account                
                  </h2>
                <p className=" text-white flex justify-center align-center mt-10">
                  Over 50 lakh investors use Screener for finding and tracking stock ideas.                
               </p>
                </div>
            </div>
            <div className="flex h-full min-h-screen w-full flex-col justify-center bg-light py-6 px-5  md:h-auto md:min-h-0 md:w-1/2 ">
                <div className="flex w-full items-center justify-center lg:w-auto block md:hidden">
                    <Logo className={'text-accent px-2 py-2 '} />
                </div>
               
               <>
               {step ?
                  (<div className="formbody">
                  {Pagedisplay()}
                  </div>):
                 null
               }
               </>
              
            </div>
         </div>
         <div id="recaptcha-container"></div>  
      </ScrollPageTop>
   )
}

export default UserRegister